module.exports = __webpack_public_path__ + "img/scrollTop.b081a228d391135320b62c87c721a3c0.svg";